/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyAuditSummaries } from 'app/entities/pharmacy-audit-summary/pharmacy-audit-summary.reducer';
import { getEntities as getPharmacyStocks } from 'app/entities/pharmacy-stock/pharmacy-stock.reducer';
import { getEntities as getPharmacyConsumableStocks } from 'app/entities/pharmacy-consumable-stock/pharmacy-consumable-stock.reducer';
import { getEntities as getPharmacyImplantStocks } from 'app/entities/pharmacy-implant-stock/pharmacy-implant-stock.reducer';
import { QtyType } from 'app/shared/model/enumerations/qty-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-audit-item.reducer';

export const PharmacyAuditItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyAuditSummaries = useAppSelector(state => state.pharmacyAuditSummary.entities);
  const pharmacyStocks = useAppSelector(state => state.pharmacyStock.entities);
  const pharmacyConsumableStocks = useAppSelector(state => state.pharmacyConsumableStock.entities);
  const pharmacyImplantStocks = useAppSelector(state => state.pharmacyImplantStock.entities);
  const pharmacyAuditItemEntity = useAppSelector(state => state.pharmacyAuditItem.entity);
  const loading = useAppSelector(state => state.pharmacyAuditItem.loading);
  const updating = useAppSelector(state => state.pharmacyAuditItem.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyAuditItem.updateSuccess);
  const qtyTypeValues = Object.keys(QtyType);

  const handleClose = () => {
    navigate(`/pharmacy-audit-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyAuditSummaries({}));
    dispatch(getPharmacyStocks({}));
    dispatch(getPharmacyConsumableStocks({}));
    dispatch(getPharmacyImplantStocks({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.quantity !== undefined && typeof values.quantity !== 'number') {
      values.quantity = Number(values.quantity);
    }
    if (values.expectedQty !== undefined && typeof values.expectedQty !== 'number') {
      values.expectedQty = Number(values.expectedQty);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...pharmacyAuditItemEntity,
      ...values,
      summary: pharmacyAuditSummaries.find(it => it.id.toString() === values.summary?.toString()),
      drugStock: pharmacyStocks.find(it => it.id.toString() === values.drugStock?.toString()),
      consumableStock: pharmacyConsumableStocks.find(it => it.id.toString() === values.consumableStock?.toString()),
      implantStock: pharmacyImplantStocks.find(it => it.id.toString() === values.implantStock?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          qtyType: 'Missing',
          ...pharmacyAuditItemEntity,
          summary: pharmacyAuditItemEntity?.summary?.id,
          drugStock: pharmacyAuditItemEntity?.drugStock?.id,
          consumableStock: pharmacyAuditItemEntity?.consumableStock?.id,
          implantStock: pharmacyAuditItemEntity?.implantStock?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyAuditItem.home.createOrEditLabel" data-cy="PharmacyAuditItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyAuditItem.home.createOrEditLabel">Create or edit a PharmacyAuditItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-audit-item-id"
                  label={translate('tinyMedicRestApp.pharmacyAuditItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditItem.quantity')}
                id="pharmacy-audit-item-quantity"
                name="quantity"
                data-cy="quantity"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditItem.expectedQty')}
                id="pharmacy-audit-item-expectedQty"
                name="expectedQty"
                data-cy="expectedQty"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditItem.qtyType')}
                id="pharmacy-audit-item-qtyType"
                name="qtyType"
                data-cy="qtyType"
                type="select"
              >
                {qtyTypeValues.map(qtyType => (
                  <option value={qtyType} key={qtyType}>
                    {translate(`tinyMedicRestApp.QtyType.${qtyType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditItem.active')}
                id="pharmacy-audit-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditItem.microSec')}
                id="pharmacy-audit-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditItem.lastupdated')}
                id="pharmacy-audit-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditItem.timestampentry')}
                id="pharmacy-audit-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyAuditItem.cursor')}
                id="pharmacy-audit-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pharmacy-audit-item-summary"
                name="summary"
                data-cy="summary"
                label={translate('tinyMedicRestApp.pharmacyAuditItem.summary')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacyAuditSummaries
                  ? pharmacyAuditSummaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-audit-item-drugStock"
                name="drugStock"
                data-cy="drugStock"
                label={translate('tinyMedicRestApp.pharmacyAuditItem.drugStock')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyStocks
                  ? pharmacyStocks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-audit-item-consumableStock"
                name="consumableStock"
                data-cy="consumableStock"
                label={translate('tinyMedicRestApp.pharmacyAuditItem.consumableStock')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyConsumableStocks
                  ? pharmacyConsumableStocks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-audit-item-implantStock"
                name="implantStock"
                data-cy="implantStock"
                label={translate('tinyMedicRestApp.pharmacyAuditItem.implantStock')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyImplantStocks
                  ? pharmacyImplantStocks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-audit-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyAuditItemUpdate;
